import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import createSlice from './createStore';

/**
 * Make sure to enforce type for each slice
 */

export function createSliceParam() {
  return (set, get) => ({
    ...createSlice(set, get),
  });
}

export function getStorageParam() {
  return {
    name: 'gg-app',
    storage: createJSONStorage(() => AsyncStorage),
    partialize: (state: Record<string, unknown>) =>
      Object.fromEntries(
        Object.entries(state).filter(
          ([key]) =>
            key !== 'securityPinOpen' &&
            key !== 'securityPinLocked' &&
            key !== 'pinGatePassedThisSession',
        ),
      ),
  };
}

const persistParameter = persist(createSliceParam(), getStorageParam());

const useStore = create(persistParameter);

export const getStoreState = () => useStore.getState();

/** Set pin gate passed flag from outside component (e.g. in navigateAfterPinAuth). Avoids calling useStore() hook in callbacks. */
export const setPinGatePassedThisSession = (value: boolean) => useStore.setState({ pinGatePassedThisSession: value });

export default useStore;
